import { Box } from '@material-ui/core';

import { ActionsOption } from '@/components/shared/components/MoreActionsMenu/types/ActionsOption';
import { SelectMenuWithIcon } from '@/components/shared/components/SuperSearchBar/components/SearchBarControls/components/SelectMenuWithIcon';
import { SearchField } from '@/components/shared/components/SuperSearchBar/components/SearchField';
import { FilterByType } from '@/components/shared/components/SuperSearchBar/types/FilterByType';
import { SearchBarFilterOptions } from '@/components/shared/components/SuperSearchBar/types/SearchBarFilterOptions';
import { ICON_NAMES } from '@/config/config';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';
import { useUser } from '@/hooks/useUser';

interface SearchBarControlProps {
  searchBarState: SearchBarFilterOptions;
  setSearchBarState: React.Dispatch<React.SetStateAction<SearchBarFilterOptions>>;
  filterByTypeOptions: ActionsOption[];
  sortByOptions: ActionsOption[];
  filterByDateOptions: ActionsOption[];
  requestLoading: boolean;
}
export const SearchBarControls = ({
  searchBarState,
  filterByTypeOptions,
  sortByOptions,
  filterByDateOptions,
  setSearchBarState,
  requestLoading,
}: SearchBarControlProps) => {
  const { background } = useCustomTheme();
  const { isMobile } = useScreen();
  const { userEntity } = useUser();

  const { filterByType, filterByDate } = searchBarState;

  const allowSearchTypeOptions = userEntity && !userEntity.isRoleMerchantChannelOrAgent();

  const getIconNameByFilterType = () => {
    switch (filterByType) {
      case FilterByType.APPLICATIONS:
        return ICON_NAMES.CONSUMER_LOAN;
      case FilterByType.MERCHANTS:
        return 'corporate_fare';
      case FilterByType.CHECKOUT_SESSIONS:
        return ICON_NAMES.CHECKOUT_SESSION;
    }
  };

  return (
    <Box position={'sticky'} top={'0px'} pt={2} pb={2} bgcolor={background} zIndex={'9999999'}>
      <SearchField
        searchBarFilter={searchBarState}
        setSearchBarFilter={setSearchBarState}
        requestLoading={requestLoading}
      />
      <Box
        pt={3}
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'flex-start'}
        flexWrap={'wrap'}
        gridGap={isMobile ? 12 : 8}
      >
        <SelectMenuWithIcon optionsArray={sortByOptions} titleTextId={'SORT_BY'} iconName={'sort'} />
        {allowSearchTypeOptions && (
          <SelectMenuWithIcon
            optionsArray={filterByTypeOptions}
            titleTextId={searchBarState.filterByType}
            iconName={getIconNameByFilterType()}
          />
        )}
        <SelectMenuWithIcon optionsArray={filterByDateOptions} titleTextId={filterByDate} iconName={'today'} />
      </Box>
    </Box>
  );
};
